import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="brutal-footer">
      <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center py-4">
        <div className="brutal-footer-brand mb-2 mb-md-0">
          TIME REGISTRY
        </div>
        <div className="d-flex flex-column flex-md-row align-items-center gap-3 mt-2 mt-md-0">
          <Link to="/terms-of-use" className="brutal-footer-link">
            TERMS OF USE
          </Link>
          <a href="mailto:info@time-registry.com" className="brutal-footer-link">
            INFO@TIME-REGISTRY.COM
          </a>
          <div className="d-flex align-items-center gap-3">
            <a 
              href="https://www.instagram.com/time_registry" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="brutal-social-icon"
              aria-label="Instagram"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="4" stroke="#FFFFFF" strokeWidth="2" fill="none"/>
                <circle cx="12" cy="12" r="4" stroke="#FFFFFF" strokeWidth="2" fill="none"/>
                <circle cx="17.5" cy="6.5" r="1.5" fill="#FFFFFF"/>
              </svg>
            </a>
            <a 
              href="https://www.tiktok.com/@time_registry" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="brutal-social-icon"
              aria-label="TikTok"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.321 5.562c-.443 0-.872-.05-1.287-.14v4.198c0 3.148-2.553 5.7-5.7 5.7s-5.7-2.552-5.7-5.7 2.552-5.7 5.7-5.7c.17 0 .335.02.495.048v2.89c-.16-.02-.325-.048-.495-.048-1.575 0-2.85 1.275-2.85 2.85s1.275 2.85 2.85 2.85 2.85-1.275 2.85-2.85V2h2.93c.123 1.52.76 2.91 1.81 3.98v.47c0 .266.21.48.475.48h.475c.265 0 .48-.214.48-.48v-.47c0-1.045-.855-1.9-1.9-1.9h-1.035V5.562z" stroke="#FFFFFF" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a 
              href="https://discord.gg/invite/f4ebCuSKNQ" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="brutal-social-icon"
              aria-label="Discord"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" stroke="#FFFFFF" strokeWidth="1.5" fill="none"/>
              </svg>
            </a>
          </div>
          <div className="brutal-footer-text text-center text-md-end">
            © {new Date().getFullYear()} TIME REGISTRY. ALL MOMENTS RESERVED.
          </div>
        </div>
      </Container>
      <style>{`
        .brutal-footer {
          background: #000000;
          color: #FFFFFF;
          border-top: 6px solid #FFFFFF;
          box-shadow: 0 -4px 0px #FFFFFF;
          margin-top: auto;
        }
        .brutal-footer-brand {
          font-weight: 900;
          font-size: 18px;
          text-transform: uppercase;
          letter-spacing: 3px;
          color: #FFFFFF;
        }
        .brutal-footer-text {
          font-weight: 700;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 2px;
          color: #FFFFFF;
        }
        .brutal-footer-link {
          font-weight: 700;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 2px;
          color: #FFFFFF;
          text-decoration: underline;
          text-decoration-thickness: 2px;
          transition: color 0.2s;
          min-height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .brutal-footer-link:hover {
          color: #FFFF00;
        }
        .brutal-social-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          border: 3px solid #FFFFFF;
          background: #000000;
          transition: all 0.1s;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;
        }
        .brutal-social-icon:hover {
          background: #FFFF00;
          border-color: #FFFF00;
          transform: translate(2px, 2px);
        }
        .brutal-social-icon:hover svg {
          stroke: #000000;
        }
        .brutal-social-icon:hover svg path,
        .brutal-social-icon:hover svg circle,
        .brutal-social-icon:hover svg rect {
          stroke: #000000;
          fill: #000000;
        }
        .brutal-social-icon svg {
          width: 20px;
          height: 20px;
          stroke: #FFFFFF;
          transition: stroke 0.1s;
        }
        @media (max-width: 768px) {
          .brutal-footer {
            width: 100%;
          }
          .brutal-footer-brand {
            font-size: 14px;
            letter-spacing: 2px;
          }
          .brutal-footer-text {
            font-size: 10px;
            letter-spacing: 1px;
            text-align: center;
          }
          .brutal-footer-link {
            font-size: 11px;
            letter-spacing: 1px;
            padding: 8px 0;
          }
          .brutal-social-icon {
            width: 40px;
            height: 40px;
            border-width: 2px;
          }
          .brutal-social-icon svg {
            width: 18px;
            height: 18px;
          }
          .brutal-footer .container {
            padding: 12px !important;
          }
          .brutal-footer .d-flex.gap-3 {
            gap: 12px !important;
          }
        }
      `}</style>
    </footer>
  );
}
